export var IdCharacterHelpType;
(function (IdCharacterHelpType) {
    IdCharacterHelpType["FirstAdventurePoints"] = "FirstAdventurePoints";
    IdCharacterHelpType["MissingPlayerLevel"] = "MissingPlayerLevel";
    IdCharacterHelpType["MissingResources"] = "MissingResources";
    IdCharacterHelpType["MissingWorkers"] = "MissingWorkers";
    IdCharacterHelpType["temporaryStorageFull"] = "temporaryStorageFull";
})(IdCharacterHelpType || (IdCharacterHelpType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/character-help-dialog/IdCharacterHelpType.ts
// module id = 296
// module chunks = 3